import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { UIDropdown } from '@irohalab/deneb-ui';

@Component({
    selector: 'app-single-select',
    imports: [
    UIDropdown
],
    templateUrl: './single-select.component.html',
    styleUrl: './single-select.component.less',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => SingleSelectComponent),
        }
    ]
})
export class SingleSelectComponent implements ControlValueAccessor {

  @Input()
  selectList!: string[];

  @Input()
  hint = '';

  selectedIdx = -1;
  selectedValue!: string;

  onChanged = (value: any) => {};
  onTouched = () => {};

  isTouched = false;
  isDisabled = false;

  writeValue(obj: any): void {
    this.selectedIdx = this.selectList.indexOf(obj);
    if (this.selectedIdx !== -1) {
      this.selectedValue = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onSelectValue(idx: number) {
    this.markAsTouched();
    this.selectedIdx = idx;
    this.selectedValue = this.selectList[this.selectedIdx];
    this.onChanged(this.selectedValue);
  }

  markAsTouched() {
    if (!this.isTouched) {
      this.onTouched();
      this.isTouched = true;
    }
  }
}
